import { defineComponent as _defineComponent } from 'vue'
import { TrackingService } from '@/client/services'


export default /*#__PURE__*/_defineComponent({
  __name: 'NavBarHelp',
  setup(__props) {

function handleLinkClick(): void {
  TrackingService.sendEvent('click:ヘルプ')
}

return { __sfc: true,handleLinkClick }
}

})